import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from 'store'

type UserNotice = NonNullable<AuthResponse['notices']>[number]

interface State {
  notices: UserNotice[]
}

const initialState: State = {
  notices: [],
}

// 로그인 응답의 notices를 큐로 보관하고 앞에서부터 하나씩 노출한다
const slice = createSlice({
  name: 'userNotice',
  initialState,
  reducers: {
    openUserNotices(state, action: PayloadAction<UserNotice[]>) {
      state.notices = action.payload
    },
    closeUserNotice(state) {
      state.notices.shift()
    },
  },
})

export default slice.reducer

export const {openUserNotices, closeUserNotice} = slice.actions

export const selectCurrentUserNotice = (state: RootState) =>
  state.userNotice.notices[0]
